import { v4 as uuidv4 } from "uuid";
import { NoteBlock } from "../block";

export interface PackageBlock extends NoteBlock {
  "package-id": string;
  type: "omega/query-omega/page/block/package/PackageBlock";
}

export function isPackageBlock(block: NoteBlock): block is PackageBlock {
  return (block as PackageBlock)["package-id"] !== undefined;
}

export const newPackageBlock = (config: {
  packageId: string;
  blockIndex: number;
  pageId: string;
  appId: string;
}) => {
  const { packageId, blockIndex, pageId, appId } = config;
  const block: PackageBlock = {
    "package-id": packageId,
    type: "omega/query-omega/page/block/package/PackageBlock",
    "block-index": blockIndex,
    "page-id": pageId,
    "app-id": appId,
    "block-id": uuidv4(),
  };
  return block;
};
